import { render, staticRenderFns } from "./m-select-object-dialog.vue?vue&type=template&id=a4779e7e&scoped=true&"
import script from "./m-select-object-dialog.vue?vue&type=script&lang=js&"
export * from "./m-select-object-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4779e7e",
  null
  
)

export default component.exports